module.exports = (__webpack_public_path__ || '') + "static/images/photo-6-ae3625872b120a53a4123a692504969b.jpg";